export const environment = {
  production: false,
  apiUrl: 'https://appservice-pd-api-n101.azurewebsites.net',
  googleMapsApiKey: 'AIzaSyBkensBN70rpDRNRD-4AcIqZ7zde-Lix-o',
  msalConfig: {
    auth: {
      clientId: '85e7aeb1-cf10-4d36-9cf5-5950d2c65e10',
      authority: 'https://portaldeweloperatest.ciamlogin.com/',
      knownAuthorities: ['portaldeweloperatest.ciamlogin.com'],
      redirectUri: window.location.origin + '/',
      postLogoutRedirectUri: window.location.origin + '/auth/login',
      navigateToLoginRequestUrl: false
    },
    cache: {cacheLocation: 'sessionStorage'}
  },
  apiConfig: {
    scopes: ['api://entraapp-pd-api-n101/access_as_user'],
    protectedResourceBaseUrl: 'https://appservice-pd-api-n101.azurewebsites.net/api/'
  },
};
